/* global toastr */
import { BaseAdminModelView } from '../model_view'
import { wrapView } from '../../smart_bps/lib/utils'
import { stateToProps } from '../../smart_bps/admin/base_view'

class DepartamentTypeObjectTypeAdminModelView extends BaseAdminModelView {
  constructor(props) {
    super(props)
  }

  /** Удаляем поиск в верхней полосе действий **/
  renderTopPanelLeftItems() {
      return []
  }

  /** Запрещаем сохранять и удалять **/
  renderContentLeftAction() {
      return []
  }
}

export default wrapView(DepartamentTypeObjectTypeAdminModelView, stateToProps)
